import {htmlQuiz, cssQuiz, javascriptQuiz, reactQuiz, jqueryQuiz, bootstrapQuiz, sassQuiz
    , lessQuiz, nodeJsQuiz, expressJsQuiz, angularQuiz, vueQuiz, jsonQuiz, httpQuiz, dHtmlQuiz,
    typescriptQuiz, reactNativeQuiz
}
 from "../quizzes/webTechnology";

import {ssrsQuiz,ssisQuiz,webApiQuiz, linqQuiz, sharePointQuiz,fsharpQuiz,vbDotNetQuiz, csharpQuiz, dotnetQuiz, aspdotnetQuiz, adodotnetQuiz, wpfQuiz} from "../quizzes/dotNet";


import {sqlQuiz, mysqlQuiz, oracleQuiz, mongodbQuiz, redisQuiz} from "../quizzes/database";

import {pythonQuiz} from "../quizzes/python";

import {phpQuiz} from "../quizzes/php";

import {javaQuiz} from "../quizzes/java";

import {cppQuiz, cQuiz, rQuiz, goQuiz, gitQuiz, bashQuiz, xmlQuiz, aiQuiz, githubQuiz, dockerQuiz,
  linuxQuiz, mathQuiz, photoshopQuiz, rustQuiz
} from "../quizzes/tech";


import {kotlinQuiz, swiftQuiz, dartQuiz} from "../quizzes/mobileApp";

import {awsQuiz} from "../quizzes/cloud";


export const quizMap = {
  html: htmlQuiz,
  css: cssQuiz,
  javascript: javascriptQuiz,
  react: reactQuiz,
  jquery: jqueryQuiz,
  bootstrap: bootstrapQuiz,
  sass: sassQuiz,
  less: lessQuiz,
  nodejs: nodeJsQuiz,
  expressjs: expressJsQuiz,
  angular: angularQuiz,
  vue: vueQuiz,
  json: jsonQuiz,
  http: httpQuiz,
  dhtml: dHtmlQuiz,
  ssrs: ssrsQuiz,
  ssis: ssisQuiz,
  webapi: webApiQuiz,
  linq: linqQuiz,
  sharepoint: sharePointQuiz,
  fsharp: fsharpQuiz,
  vbdotnet: vbDotNetQuiz,
  sql: sqlQuiz,
  mysql: mysqlQuiz,
  oracle: oracleQuiz,
  mongodb: mongodbQuiz,
  redis: redisQuiz,
  python: pythonQuiz,
  php: phpQuiz,
  java: javaQuiz,
  cpp: cppQuiz,
  c: cQuiz,
  csharp: csharpQuiz,
  dotnet: dotnetQuiz,
  "asp-dotnet": aspdotnetQuiz,
  "ado-dotnet": adodotnetQuiz,
  wpf: wpfQuiz,
  r: rQuiz,
  go: goQuiz,
  git: gitQuiz,
  bash: bashQuiz,
  xml: xmlQuiz,
  ai: aiQuiz,
  github: githubQuiz,
  docker: dockerQuiz,
  linux: linuxQuiz,
  math: mathQuiz,
  photoshop: photoshopQuiz,
  kotlin: kotlinQuiz,
  swift: swiftQuiz,
  dart: dartQuiz,
  rust: rustQuiz,
  typescript: typescriptQuiz,
  "react-native": reactNativeQuiz,
  aws: awsQuiz,
};
